export default "__VITE_ASSET__e2560cdc__"